<template>
    <div class="tags">
        <h3>{{ collectionLabel }}</h3>
        <router-link v-for="(edition, index) in editions" :key="index" :to="urlPrefix + edition.slug" class="small" :class="{ active: edition.id === activeEditionId }">
            <span>{{ helpers.getTranslation(edition, 'title') }}</span>
        </router-link>

        <router-link :to="urlPrefix + 'international'">
            <span>{{ internationalLabel }}</span>
        </router-link>

        <router-link :to="urlPrefix + 'permanent'">
            <span>{{ permanentLabel }}</span>
        </router-link>

        <router-link :to="urlPrefix + 'all'">
            <span>{{ editionLabel }}</span>
        </router-link>
    </div>
</template>

<script>
import helpers from './../../helpers'
export default {

    data: function() {
        return {
            helpers: helpers
        }
    },
    props: {
        editions: { required: true },
        activeFilter: {required: true},
        activeEditionId: { required: true },
    },
    computed: {
        urlPrefix: function() {
            if(helpers.getLocale() === 'nl') {
                return '/' + helpers.getLocale() + '/' + this.activeFilter['slug-nl'] + '/editie/';
            }
            return '/' + helpers.getLocale() + '/'  + this.activeFilter['slug-en']  + '/edition/';
        },
        editionLabel: function(){
            if(helpers.getLocale() === 'nl') {
                return 'Alle';
            }
            return 'All';
        },
        internationalLabel: function(){
            if(helpers.getLocale() === 'nl') {
                return 'Internationaal';
            }
            return 'International';
        },
        permanentLabel: function(){
            if(helpers.getLocale() === 'nl') {
                return 'Permanent';
            }
            return 'Permanent';
        },
        collectionLabel: function(){
            if(helpers.getLocale() === 'nl') {
                return 'Collectie';
            }
            return 'Collection';
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/site/components/catalog-filter/edition-switcher.vue